import jwt_decode from 'jwt-decode'
import { localStorage, cookieStorage } from '@/tool/storage';
import { login, logout, refresh } from '@/api/user';
import { getUserInfo, getUserIsOpenPay } from '@/api/user';
import { CookieEnum } from '@/tool/enum';
import { getMyTeam, getTeamRole, getTeamCount } from '@/api/member/memberTeam';
let userInfo = localStorage.get("userInfo")
let teamInfo = localStorage.get("teamInfo")

export default {
    state: {
        userInfo: userInfo || {},
        refreshToken: cookieStorage.get(CookieEnum.refreshToken),
        // 用户浏览记录
        recordsInfo: {},
        teamInfo: teamInfo || {}
    },
    mutations: {
        setRefreshToken(state, token) {
            state.refreshToken = token
        },
        setUserInfo(state, data) {
            state.userInfo = Object.assign({}, state.userInfo, data)
            localStorage.set("userInfo", state.userInfo)
        },
        setTeamInfo(state, data) {
            state.teamInfo = Object.assign({}, state.teamInfo, data)
            localStorage.set("teamInfo", state.teamInfo)
        },
        clearTeamInfo(state) {
            localStorage.remove('teamInfo')
            state.teamInfo = {}
        },
        clearUserInfo(state) {
            localStorage.remove('userInfo')
            state.userInfo = {}
            state.refreshToken = ''
        },
        setRecordsInfo(state, data) {
            state.recordsInfo = data
        },
    },
    actions: {
        async SET_TOKEN({ commit }, { access_token, refresh_token, uid, uuid }) {
            const accessTokenExpires = new Date((jwt_decode(access_token).exp - 60) * 1000)
            const refreshTokenExpires = new Date((jwt_decode(refresh_token).exp - 60) * 1000)
            cookieStorage.set(CookieEnum.accessToken, access_token, { "expires": accessTokenExpires, domain: 'micetech.cn' });
            cookieStorage.set(CookieEnum.refreshToken, refresh_token, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
            cookieStorage.set(CookieEnum.uid, uid, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
            var millisecond = new Date().getTime();
            cookieStorage.set('uuid', uuid, { "expires": new Date(millisecond + 60 * 1000 * 60*24*365), domain: process.env.VUE_APP_DOMAIN || '' });
            // state.userInfo.uid = uid
            // state.userInfo.accessToken = access_token;
            // state.userInfo.refreshToken = refresh_token;
            commit('setRefreshToken', refresh_token)
            commit("setUserInfo", { accessToken: access_token, refreshToken: refresh_token, uid, uuid })
        },
        storeGetUserInfo({ commit }) {
            // 获取用户基本信息
            // 获取是否开通平台支付
            // 获取用户团队信息
            // Promise.all([getUserInfo(), getMyTeam(), getUserIsOpenPay()]).then(res => {
            //     const [userInfo, teamInfo, isOpenPay] = res
            //     if (teamInfo.face) {
            //         teamInfo.face = JSON.parse(teamInfo.face)[0]
            //     }
            //     if (teamInfo.id) {
            //         getTeamRole(teamInfo.id).then(info => {
            //             const { role } = info
            //             commit('setUserInfo', { teamRole: role })
            //             commit('setUserInfo', { myInTeamInfo: info })
            //         })
            //     }
            //     commit('setUserInfo', { ...userInfo, teamInfo, isOpenPay })
            //     // console.log(state.userInfo, 'sssss')
            // })
            getUserInfo().then(userInfo => {
                userInfo.regionId = userInfo.cityId
                getUserIsOpenPay().then(isOpenPay => {
                    commit('setUserInfo', { ...userInfo, isOpenPay })
                })
                getMyTeam().then(teamInfo => {
                    if (!teamInfo) {
                        return commit('clearTeamInfo')
                    }
                    // if (teamInfo.face) {
                    //     teamInfo.face = JSON.parse(teamInfo.face)
                    // }
                    commit('setTeamInfo', teamInfo)
                    if (teamInfo.id) {
                        getTeamRole(teamInfo.id).then(info => {
                            commit('setTeamInfo', { myInTeamInfo: info })
                        })

                        getTeamCount(teamInfo.id).then(info => {
                            commit('setTeamInfo', { teamCount: info })
                        })
                    }
                })
            })

        },
        refreshAccessToken({ commit }) {
            return new Promise((resolve, reject) => {
                const refreshToken = cookieStorage.get(CookieEnum.refreshToken);

                if (!refreshToken) {
                    return reject()
                }
                refresh(refreshToken)
                    .then((response) => {
                        const { access_token, refresh_token, uid } = response;
                        const accessTokenExpires = new Date((jwt_decode(access_token).exp - 60) * 1000)
                        const refreshTokenExpires = new Date((jwt_decode(refresh_token).exp - 60) * 1000)
                        cookieStorage.set(CookieEnum.accessToken, access_token, { "expires": accessTokenExpires, domain: 'micetech.cn' });
                        cookieStorage.set(CookieEnum.refreshToken, refresh_token, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
                        cookieStorage.set(CookieEnum.uid, uid, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
                        // state.userInfo.uid = uid
                        // state.userInfo.accessToken = access_token;
                        // state.userInfo.refreshToken = refresh_token;
                        commit("setUserInfo", response)
                        commit('setRefreshToken', refresh_token)
                        return resolve(access_token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         * 登录
         */
        login({ state, commit, dispatch }, loginData) {
            // const { username, password, code, uuid, mobile, grant_type, } = loginData;
            dispatch("resetToken")
            return new Promise((resolve, reject) => {
                login(loginData)
                    .then((response) => {
                        const { access_token, refresh_token, uid } = response;
                        const accessTokenExpires = new Date((jwt_decode(access_token).exp - 60) * 1000)
                        const refreshTokenExpires = new Date((jwt_decode(refresh_token).exp - 60) * 1000)
                        cookieStorage.set(CookieEnum.accessToken, access_token, { "expires": accessTokenExpires, domain: 'micetech.cn' });
                        cookieStorage.set(CookieEnum.refreshToken, refresh_token, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
                        cookieStorage.set(CookieEnum.uid, uid, { "expires": refreshTokenExpires, domain: 'micetech.cn' });
                        commit("setUserInfo", response)
                        commit('setRefreshToken', refresh_token)
                        console.log(state.userInfo)
                        resolve(access_token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        /**
         *  获取用户信息（昵称、头像、角色集合、权限集合）
         */
        // getUserInfo() {
        //     return new Promise((resolve, reject) => {

        //         getUserInfo()
        //             .then(({ data }) => {
        //                 if (!data) {
        //                     return reject('Verification failed, please Login again.');
        //                 }
        //                 const { username, face, roles, authorities } = data;
        //                 this.roles = roles;
        //                 this.nickname = username;
        //                 this.avatar = face;
        //                 this.authorities = authorities;
        //                 resolve(data);
        //             })
        //             .catch((error) => {
        //                 reject(error);
        //             });
        //     });
        // },

        /**
         *  注销
         */
        logout({ dispatch }) {
            return new Promise((resolve, reject) => {
                logout()
                    .then(() => {
                        localStorage.clear();
                        dispatch("resetToken")
                        resolve(null);
                        sessionStorage.removeItem('path')
                    })
                    .catch((error) => {

                        localStorage.clear();
                        dispatch("resetToken")
                        sessionStorage.removeItem('path')
                        reject(error);
                    });
            });
        },

        /**
         * 清除 Token
         */
        resetToken({ commit }) {
            return new Promise((resolve) => {
                commit("clearUserInfo")
                commit('clearTeamInfo')
                localStorage.clear();
                cookieStorage.clear();
                sessionStorage.removeItem('checkSuccess')
                resolve(null);
            });
        },
    },
    namespaced: true
}
